import { useState } from "react";
import { saveGrade } from "../Api/GradeMaster";
import { Container, Form, Button, Row, Col, Accordion, AccordionItem, AccordionBody, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";
import "../Styling/Title.css";
import "../Styling/Accordion.css";
import "../Styling/SaveButton.css";

const GradeMaster = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userId = userDetails?.userId;
  const [gradeData, setGradeData] = useState({
    grade: "",
    description: "",
  });

  const handleChange = (e) => {
    setGradeData({ ...gradeData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await saveGrade(gradeData, userId); 
      toast.success(`🦄 Grade Added Successfully`);
      setGradeData({ grade: "", description: "" });
      navigate("/gradeMaster");
    } catch (error) {
      toast.error(`🦄 Error saving grade: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="main-content expand">
      <Container fluid className="fields-container">
        <h2 className="fields-title">Grade Master</h2>

        {loading && (
          <div className="loading-overlay">
            <Sample14 />
          </div>
        )}

        <Form onSubmit={handleSubmit} className="fields-form">
          <Accordion defaultActiveKey="0" className="grade-master-accordion">
            <AccordionItem eventKey="0">
              <AccordionBody>
                <Row className="g-3">
                  <Col md={6}>
                    <Form.Group controlId="grade">
                      <Form.Label>Grade <span className="text-red">**</span></Form.Label>
                      <Form.Control
                        type="text"
                        name="grade"
                        value={gradeData.grade}
                        onChange={handleChange}
                        required
                        placeholder="Enter Grade"
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group controlId="description">
                      <Form.Label>Description <span className="text-red">**</span></Form.Label>
                      <Form.Control
                        type="text"
                        name="description"
                        value={gradeData.description}
                        onChange={handleChange}
                        required
                        placeholder="Enter Description"
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </AccordionBody>
            </AccordionItem>
          </Accordion>

          <div className="fields-btn-container" style={{ marginTop: 16 }}>
            <Button 
              type="submit" 
              variant="primary" 
              className="fields-submit" 
              disabled={loading}
            >
              {loading ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Saving…
                </>
              ) : (
                "Save Grade"
              )}
            </Button>
          </div>
        </Form>
      </Container>
    </div>
  );
};

export default GradeMaster;